import React from 'react'

import QuestionsPane from '../../../../../sharedLegacy/features/WebinarSidebarFeature/components/QuestionsPane/QuestionsPane'

import './FocusQuestions.scss'

const FocusQuestions = () => {
  return (
    <div className="focus-questions-pane">
      <QuestionsPane commonCommentsProps={{}} unreadQuestionsList={[]} />
    </div>
  )
}

export { FocusQuestions }
